// IMPORTS
import _ from 'lodash'
import axios from 'axios'
import {notify} from '@/js/utils.js'

// COMPARTIDO CON LARAVEL Y APP
// V.1.0

const state = {
	numerossky: [],
    waitingPIN: null
}

const getters = {
    skyaccountGetNumerosSky: state => { return state.numerossky },
    skyaccountGetIsWaitingPin: state => { return state.waitingPIN }
}

const mutations = {
    skyaccountSetNumerosSky: (state, payload) => { state.numerossky = payload },
    skyaccountClear: (state) => { state.numerossky = []; state.waitingPIN = null },
}

const actions = {
    skyaccountTryToLinkNumber: async ({getters, commit}, payload) => {
        try {
            let api2workwith = ((!payload.id || !payload.pin))? 'skyaccount/linknewmsisdn' : 'skyaccount/activatemsisdnwithpin',
                response = await axios.post(api2workwith, payload)
            
            // ANALIZA SI HAY MENSAJES PARA EL USUARIO, duración extendia.
            if (response.msg) 
                notify(response.msg, response.class || 'info')
            
            return response
        } catch (e) {
            console.error(e)
            notify(e)
        }
    },
	skyaccountUpdate: async ({commit}) => {
        try {
            // RESPONSE
            let response = await axios.get('skyaccount/getmine', { withCredentials: false })

            // ANALIZA SI HAY MENSAJES PARA EL USUARIO, duración extendia.
            if (response.msg) 
                notify(response.msg, response.class || 'info')
            
            // RESPONSE PROCESSING
            if(response.status){
                commit('skyaccountSetNumerosSky', response.data.numerosblackfon)
            }
        } catch(e) {
            console.error(e)
            notify(e)
        }
    }
}

// EXPORTS
export default {
	state,
	getters,
	mutations,
	actions
};